//© 2025 Kaitlyn Troxell
import React, { useState } from "react";

function AssignmentModal({ 
  selectedTask, 
  contractors, 
  assignContractorToTask, 
  setSelectedTask 
}) {
  const [searchQuery, setSearchQuery] = useState("");

  // Filter contractors by search query
  const filteredContractors = contractors.filter(contractor => {
    const matchesSearch = 
      (contractor.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.trade || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.phone || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.email || "").toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearch;
  });

  // Group contractors by trade for better organization
  const groupedContractors = filteredContractors.reduce((acc, contractor) => {
    const trade = contractor.trade || 'Other';
    if (!acc[trade]) {
      acc[trade] = [];
    }
    acc[trade].push(contractor);
    return acc;
  }, {});

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
          <div style={{ flex: 1 }}>
            <h3 className="modal-title" style={{ marginBottom: '5px' }}>Assign Contractor</h3>
            <p className="modal-subtitle" style={{ margin: 0 }}>
              Task: <strong>{selectedTask.title}</strong>
            </p>
          </div>
          <button
            onClick={() => setSelectedTask(null)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              color: '#666',
              cursor: 'pointer',
              padding: '0',
              lineHeight: '1',
              marginLeft: '10px'
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        {/* Search Box */}
        <div className="search-box" style={{ marginBottom: '15px', position: 'relative' }}>
          <input
            type="text"
            placeholder="Search contractors..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="form-input"
            style={{ fontSize: '14px', padding: '8px 32px 8px 8px' }}
            autoFocus
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#666',
                padding: '0 4px'
              }}
            >
              ×
            </button>
          )}
        </div>

        <div className="modal-section">
          <button
            onClick={() => assignContractorToTask(selectedTask.id, null)}
            className={`contractor-btn unassigned ${selectedTask.contractor === null ? 'selected' : ''}`}
          >
            Unassigned
          </button>
        </div>

        {Object.keys(groupedContractors).length === 0 && searchQuery && (
          <div className="empty-state" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            No contractors found matching "{searchQuery}"
          </div>
        )}

        {Object.keys(groupedContractors).map(trade => (
          <div key={trade} className="modal-section">
            <h4 className="trade-group-title">
              {trade}
            </h4>
            {groupedContractors[trade].map(contractor => (
              <button
                key={contractor.id}
                onClick={() => assignContractorToTask(selectedTask.id, contractor.id)}
                className={`contractor-btn ${selectedTask.contractor === contractor.id ? 'selected' : ''}`}
              >
                <div className="contractor-btn-name">
                  {contractor.name}
                  {contractor.preferred && " ⭐"}
                </div>
                <div className="contractor-btn-phone">
                  {contractor.phone}
                </div>
              </button>
            ))}
          </div>
        ))}

        <div className="modal-actions">
          <button
            onClick={() => setSelectedTask(null)}
            className="modal-cancel-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignmentModal;